import { createFileRoute } from "@tanstack/react-router";
import { LegacyBrRedirect } from "@/site/components/birthday-request/legacy-br-redirect";

/** Legacy `/bday/<member magic_link>` (the shareable Birthday-Request link). */
export const Route = createFileRoute("/bday/$magic")({
  component: () => <LegacyBrRedirect />,
});
